import { render, staticRenderFns } from "./PermissionsContactsForm.vue?vue&type=template&id=12f9f0c5&scoped=true&"
import script from "./PermissionsContactsForm.vue?vue&type=script&lang=js&"
export * from "./PermissionsContactsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12f9f0c5",
  null
  
)

export default component.exports